/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { showToastError } from "~/components/Toast";
import { ERROR_TEXT } from "~/constants";
import { ROUTES } from "~/routing";

type Props = RouteProps & {
  component: React.FC;
  grantAccess: boolean;
};

export function GuardRoute({
  component: Component,
  grantAccess,
  ...rest
}: Props) {
  return (
    <Route
      {...rest}
      render={(props) =>
        grantAccess ? (
          <Component {...props} {...grantAccess} />
        ) : (
          <>
            {showToastError(ERROR_TEXT.accessDenied)}
            <Redirect to={ROUTES.index} />
          </>
        )
      }
    />
  );
}
